import { render, staticRenderFns } from "./PNav.vue?vue&type=template&id=246b4f20"
import script from "./PNav.vue?vue&type=script&lang=js"
export * from "./PNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports